// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__NbjFn","fake-block":"Footer_fake-block__GFfch"};